import { getStartEndDate } from './util';

// map filters keys to query params
const mapFromFilterKeys = {
  builds: 'build',
  oses: 'os',
  browsers: 'browser',
  tags: 'tag',
  owners: (owners) => ({
    scope: owners.find((item) => item === 'Organization') ? 'organization' : 'single',
    owner: owners,
  }),
};

// map payload keys to filter keys
const mapToFilterKeys = (
  Object
    .entries(mapFromFilterKeys)
    .reduce((acc, [key, value]) => {
      acc[value] = key;
      return acc;
    }, {})
);

// Reduce `filters` (a nested Immutable.Map) to { [key]: [value1, value2, ...] }.
// The result is safe to pass as query params to axios.
export const getFilterParamsAdapter = (filters, mapping = mapFromFilterKeys) => (
  filters.reduce((acc, value, key) => {
    if (!value.get('selectedItems').size) {
      return acc;
    }

    const newKey = key in mapping ? mapping[key] : key;

    if (typeof newKey === 'function') {
      return { ...acc, ...newKey(value.get('selectedItems').toJS()) };
    }

    acc[newKey] = value.get('selectedItems').toJS();
    return acc;
  }, {})
);

// Replace playload aggregations keys to match filter keys.
export const getFilterPayloadAdapter = (data, mapping = mapToFilterKeys) => (
  Object
    .entries(data)
    .reduce((acc, [key, value]) => {
      const newKey = key in mapping ? mapping[key] : key;
      acc[newKey] = value;
      return acc;
    }, {})
);

/**
 * Collect time filter params.
 * @param {Map} dateFilter
 * @param {string} dateFilter.type
 * @param {number} dateFilter.value
 */
export const getTimeFilterParams = (dateFilter, base = Date.now()) => {
  const { startDate, endDate } = getStartEndDate(dateFilter, base);
  return {
    start: Math.floor(startDate.getTime() / 1000),
    end: Math.floor(endDate.getTime() / 1000),
  };
};

/**
 * Collect pagination params.
 * @param {Map} pagination
 * @param {string} pagination.size
 * @param {number} pagination.activePage
 */
export const getPaginationParams = (pagination) => {
  const size = pagination.get('size');
  const activePage = pagination.get('activePage');
  return {
    size,
    skip: activePage * size,
  };
};
